// components/ProtectedRoute.jsx
import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";

export default function ProtectedRoute({ children, allowedRoles }) {
  const { user } = useContext(AuthContext);

  // Not logged in → go to login/home
  if (!user) {
    return <Navigate to="/" replace />;
  }

  // Logged in but role not allowed
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    const redirectPath =
      user.role === "admin"
        ? "/admin"
        : user.role === "superadmin"
        ? "/admin"
        : user.role === "staff"
        ? "/user"
        : "/";

    return <Navigate to={redirectPath} replace />;
  }

  return children;
}
